// Soft cap on the executive-summary length used to gate avatar-video generation.
// ~400 visible characters of TTS speech ≈ 30s, the practical limit for a video.
// It is NOT enforced on save — only surfaced as a counter and a pre-generation guard.
export const EXCERPT_MAX_CHARS = 400;

/**
 * Visible-character count of rich-text HTML — i.e. roughly what the TTS engine
 * will actually speak (tags stripped, entities decoded, block/line breaks
 * counted as a single space). Used for the executive-summary counter and the
 * pre-generation length guard so the two always agree.
 */
export const getExcerptLength = (html: string): number => {
  if (!html) return 0;
  const withBreaks = html.replace(/<\/(p|div|li|h[1-6])>|<br\s*\/?>/gi, " ");
  const el = document.createElement("div");
  el.innerHTML = withBreaks;
  return (el.textContent || "").replace(/\s+/g, " ").trim().length;
};
